const containers = Array.from(document.querySelectorAll('.header__search, .header__menu-search'));

// // Disable input initially
// if (searchInput) {
// 	searchInput.disabled = true;
// }

containers.forEach((container) => {
	const input = container.querySelector('.search-form__input');
	const form = container.querySelector('form.search-form');
	if (!input) return;

	const open = () => {
		container.classList.add('active');
		input.focus();
	};

	const close = () => {
		container.classList.remove('active');
		input.value = '';
	};

	input.addEventListener('click', () => {
		if (!container.classList.contains('active')) {
			open();
		}
	});

	if (form) {
		form.addEventListener('submit', (e) => {
			const value = input.value.trim();
			if (value === '') {
				e.preventDefault();
				open();
				return;
			}
			// Allow submit; the next page will render the input empty (see searchform.php).
		});
	}

	// Close when clicking outside
	document.addEventListener('click', (e) => {
		if (container.classList.contains('active') && !container.contains(e.target)) {
			close();
		}
	});

	// Close on Escape
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && container.classList.contains('active')) {
			close();
		}
	});
});
